// Module
var code = "<section class=\"acclaro-grid\"> <table v-bind:id=\"'ag-' + id\" class=\"ag-table\"> <thead> <tr> <th v-for=\"header in tableData.headers\">{{header.name}}</th> </tr> </thead> </table> </section> ";
// Exports
module.exports = code;